"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_apollo_1 = require("react-apollo");
var userCartGQL_1 = require("./userCartGQL");
var UserCartContext = React.createContext({
    cartData: null,
    // tslint:disable-next-line: no-empty
    refetch: function () { }
});
exports.UserCartProvider = UserCartContext.Provider;
exports.UserCartConsumer = UserCartContext.Consumer;
exports.withUserCart = function (ComponentClass) { return function (props) { return (React.createElement(exports.UserCartConsumer, null, function (userCart) {
    var fullProps = Object.assign({}, props, { userCart: userCart });
    return (React.createElement(ComponentClass, __assign({}, fullProps)));
})); }; };
var UserCart = /** @class */ (function (_super) {
    __extends(UserCart, _super);
    function UserCart(props) {
        return _super.call(this, props) || this;
    }
    UserCart.prototype.componentDidMount = function () {
        this.props.cartFetchMutationFn();
    };
    UserCart.prototype.render = function () {
        var fetchedData = this.props.fetchedData;
        var cartData = fetchedData && fetchedData.getUserCart || null;
        return (React.createElement(exports.UserCartProvider, { value: {
                refetch: this.props.cartFetchMutationFn,
                cartData: cartData
            } }, this.props.children));
    };
    return UserCart;
}(React.Component));
exports.default = (function (props) { return (React.createElement(react_apollo_1.Mutation, { mutation: userCartGQL_1.default }, function (cartFetchMutation, mutationResult) { return (React.createElement(UserCart, { cartFetchMutationFn: cartFetchMutation, fetchedData: mutationResult.data }, props.children)); })); });
